/**
 * This will scroll down when user selects language
 * @example ng-sidebar-scroll
 */

const ngSidebarScroll = [() => {
    return {
        link: function ($scope, $element, $params) {
            $scope.$watch('mobileLanguagesDisplay', function (isVisible) {
                if ( isVisible ) {
                    setTimeout(() => {
                        $element[0].scrollTop = $element[0].scrollHeight;
                    }, 50 );
                }
            });

        }
    }
}];

export default ngSidebarScroll;

